<template >
  <div class="search" @scroll="onScroll">
    <div class="search-top">
      <!-- <form action onsubmit="return false"> -->
        <input type="search" name="search-input" v-model="defaultKey" @focus="focusInput" :placeholder="(typeof defaultKey == 'object' && defaultKey && defaultKey.name) || '搜索全网商品'">
      <!-- </form> -->
      <button class="search-cancel" @click="cancel">取消</button>
    </div>

    <div class="result-list" v-if="isSearch">
      <nav-bar class="p-nav-bar"
        :query="`keyword=${key}`"
        :type="'search'"
        @navshow="navshow"
        @action="action"
        @list="list"
      />

      <div class="empty" v-if="!seaching && !items.length">
        <img src="../assets/icon-empty.png">
        <p>没有搜索到你要的结果</p>
      </div>

      <search-list :data="items" :keys="key" :suggest="suggest"/>

      <span class="go-cart" @click="goCart"></span>
    </div>

    <associate-list 
      :list="associateList" 
      :aKey="aKey"
      @selectItem="search"
      v-if="isAssociate && !isCouponSearch"/>

    <div class="search-key" v-if="!isSearch && !isCouponSearch">
      <div class="latest-key"
        v-if="history.length > 1"
      >
        <span class="search-clear" @click="clearSearch"></span>
        <h2>搜索历史</h2>
        <ul id="history-key">
          <li
            v-for="(item, index) in history"
            v-if="item && index < maxIndex"
            @click="goSearch(item, '历史词')">{{ item }} </li>

          <li
            class="item-more"
            @click="showMoreHist" v-if="hideMore && history.length > 6"></li>
        </ul>
      </div>

      <div class="hot-key"
        v-if="hotItem && hotItem.hotKeys.length > 0"
      >
        <h2>热门发现</h2>
        <ul>
          <li :class="{'high-light': item.highlight}" v-for="item in hotItem.hotKeys" @click="goLink(item, true, '热门搜索')"><i></i>{{ item.name }} </li>
        </ul>
      </div>

      <div class="search-banner" v-if="banners.length">
        <div class="img-item" v-for="banner in banners" @click="jumpBanner(banner.link)"> 
          <img :src="banner.src" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import beastMain from '@/components/app-main'
import navBar from '@/components/navbar'
import simpleProduct from '@/components/simple-product'
import track from '@/track'

import searchList from './list.vue'
import associateList from './associate-list.vue'
import queryString from 'query-string'

const queParams = queryString.parse(window.location.search)

import {
  getLink 
} from '@/components/app-menu/util'
import { transformLink } from '@/link'

import {
  searchByKeywords,
  getHotSearch,
  getAssociate
} from '../apis'

const KEY_CODE = {
  13: 'iOS'
}

const MIN_HEIGHT = 35

export default {
  components: {
    beastMain,
    navBar,
    searchList,
    associateList
  },

  props: ['isShow','isCouponSearch'],

  data () {
    return {
      ipt: null,
      query: '',
      key: '',
      aKey: '',
      items: [],
      banners: [],
      associateList: null,
      defaultKey: '',
      suggest: null,
      hotItem: null,
      history: [],
      isSearch: false,
      increase: 0,
      loaded: false,
      isDefault: false,
      isAssociate: false,
      enable: true,
      hideMore: false,
      maxIndex: 7,
      seaching: false,
      searchType: '搜索词',
      sortField: 'SYNTHESIS', // PRICE
      sortOrder: 'DESC'// ASC
    }
  },
  created () {
    this.getHotSearch()
    this.history = this.getKeys().split('-')
    
    this.$nextTick(() => {
      const hist = document.querySelector('#history-key')
      console.log(hist,'11')
      if (!hist) return
      console.log(hist.clientHeight,'hhs')
      if (hist.clientHeight >= MIN_HEIGHT * 2) {
        this.hideMore = true
      }
      else {
        this.hideMore = false
      }
    })
  },
  mounted () {
    this.ipt = document.querySelector('input[name="search-input"]')
    this.ipt.focus()
  },

  watch: {
    defaultKey (val) {
      if (!val) { 
        this.reset()
        this.isSearch = false
        this.isAssociate = false
        return
      }

      if (typeof val !== 'object') {
        this.isDefault = false
      }

      if (this.enable && typeof val !== 'object') {
        setTimeout(() => {
          this.getAssociate(val)
        }, 50)
      }
      else {
        this.isAssociate = false
      }
    }
  },

  methods: {
    init () {
      const bd = document.body
      const vm = this

      this.ipt.value = ''

      bd.addEventListener('keyup', function (e) {
        if (!(e.keyCode in KEY_CODE)) return
        vm.reset()
        vm.isAssociate = false
  
        if (vm.isDefault) {
          sa.track('SearchClick', {
            ...sa.getReferPageName(),
            search_type: '默认词',
            search_word: vm.defaultKey.name,
            if_directional_skip: true
          })
          vm.goLink(vm.defaultKey)
          track({
            name: 'default-search',
            attrs: {
              keyword: vm.defaultKey.name, 
              type: vm.defaultKey.linkType
            },
            wait: false
          })
        }
        else {
          vm.key = vm.ipt.value || vm.defaultKey.name
          vm.getResult(vm.key)
        }
      })
    },

    getAssociate (keyword) {
      getAssociate(keyword)
      .then(({data}) => {
        this.associateList = data

        if (data.length) {
          this.aKey = keyword
          this.isAssociate = true
        }
        else {
          this.isAssociate = false
        }
      })
      .catch(err => {})
    },

    showMoreHist () {
      this.hideMore = false
      this.maxIndex = this.history.length
    },

    onScroll (e) {
      const tar = e.currentTarget
      const height = tar.clientHeight
      const scrollTop = tar.scrollTop
      const scrollHeight = tar.scrollHeight

      if (scrollTop + height >= scrollHeight) {
        this.getResult(this.key, this.query)
      }
    },

    focusInput () {
      this.searchType = '搜索词'
      this.getAssociate(this.key)
    },

    search (item) {
      console.log('search11')
      this.reset()
      this.enable = false
      this.goLink(item, false, '联想词')
    },

    action (type, sort) {
      this.sortField = type
      this.sortOrder = sort
      this.reset()
      this.$nextTick(() => {
        this.getResult(this.key, this.query)
      })
    },

    list (query, selected) {
      this.showlist = true
      this.clearFilter = false

      if (!query) return

      this.reset()

      this.$nextTick(() => {
        this.getResult(this.key, query)
      })
    },

    navshow (select) {
      this.showlist = false
    },

    reset () {
      this.items = []
      this.increase = 0
      // this.finish = false
      // this.netError = false
      // this.isEnded = false
    },

    goLink (item, flag, searchType) {
      console.log('search22', searchType)
      if (flag) {
        track({
          name: 'hot-search',
          attrs: {
            keyword: item.name,
            type: item.linkType
          },
          wait: false
        })
      }

      this.searchType = searchType || '搜索词'

      if (!item.deeplink) {
        this.getResult(item.name)
        return
      }

      const link = getLink(item.deeplink)
      sa.track('SearchClick', {
        ...sa.getReferPageName(),
        search_type: this.searchType,
        search_word: item.name,
        if_directional_skip: true
      })
      window.location.href = link
    },

    jumpBanner (link) {
      const _link = transformLink({link})

      window.location.href = _link
    },

    getResult (key, query) {
      if (!key) return
      
      this.ipt.blur()
      this.enable = false
      this.defaultKey = key
      this.key = key
      this.setKeys(key)

      track({
        name: 'search',
        attrs: {
          keyword: key
        },
        wait: false
      })
      
      this.$showLoading()

      let que = query

      if (!que) {
        que = `keyword=${key}`
      }

      this.query = queParams && queParams.couponSampleId ? `${que}&couponSampleId=${queParams.couponSampleId}` : `${que}`

      
      searchByKeywords(`${this.query}&sortField=${this.sortField}&sortOrder=${this.sortOrder}`, this.increase)
      .then(({ data }) => {
        this.$hideLoading()

        const {
          list,
          suggest,
          jump
        } = data

        // 发起搜索请求
        sa.track('SearchClick', {
          ...sa.getReferPageName(),
          search_type: this.searchType,
          search_word: key,
          if_directional_skip: jump ? true : false
        })


        if (jump) {
          const link = transformLink({
            link: jump
          })
          window.location.href = link
          return
        }

        if (!list) return
        
        this.isSearch = true

        const {
          items
        } = list

        this.increase++

        this.items = this.items.concat(items)

        this.enable = true
        this.seaching = false
        this.suggest = suggest
      })
      .catch(err => {
        this.$hideLoading()
        this.$alert(err.message || '系统异常')
      })
      this.isAssociate = false
    },

    getHotSearch () {
      getHotSearch()
      .then(data => {
        this.hotItem = data
        this.defaultKey = data.defaultKeyword
        this.banners = data.banners

        if (this.defaultKey && this.defaultKey.deeplink) {
          this.isDefault = true
        }

        this.$nextTick(() => {
          this.init()
        })
      })
    },

    goSearch (key, searchType) {
      this.key = key
      this.searchType = searchType
      this.getResult(key)
    },

    getKeys () {
      const history = localStorage.getItem('__bstkeys') || ''
      return history
    },

    setKeys (val) {
      let history = this.getKeys()
      let temp = history.split('-')

      if (~temp.indexOf(val)) {
        return
      }
      
      history += val + '-'

      localStorage.setItem('__bstkeys', history)
    },

    clearSearch () {
      localStorage.removeItem('__bstkeys')
      this.history = []

      this.$nextTick(() => {
        this.ipt.value = ''
      })
    },

    cancel () {
      this.isSearch = false
      this.$emit('close')
    },

    goCart () {
      window.location.href = '/cart'
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// main.vue?22fd2743